class AntdUtils {
  message;
  notification;
  modal;

  setMessageInstance(message) {
    this.message = message;
  }

  setNotificationInstance(notification) {
    this.notification = notification;
  }

  setModalInstance(modal) {
    this.modal = modal;
  }
}

export const antdUtils = new AntdUtils();
